export enum ShipmentFilterLabels {
  Create = 'Create',
  Update = 'Update',
  Cancel = 'Cancel',
  Apply = 'Apply',
  Reset = 'Reset',
  BackToFilter = 'BackToFilter'
}
